/**
 * Textos do shell, literais do `07_VOZ_E_TEXTOS.md` (§3 e §5) e da D64. Os rótulos de acessibilidade e os avisos
 * de estado foram aprovados na D162 (`07_VOZ` §5, linha "Shell").
 * Cada app pode passar os seus por props; o pacote não espalha texto em JSX.
 */
export const SHELL_TEXT = {
    // Aprovados: D64 (destinos) e 07_VOZ §5 (Leitura) e §3 (Rodapé).
    nav: {
        inicio: "Início",
        criar: "Criar",
        videos: "Vídeos",
        // Hífen invisível (U+00AD): só aparece se a palavra não couber na barra inferior (A++ no celular).
        comunidade: "Comu­nidade",
        perfil: "Perfil",
    },
    letra: "Letra",
    tamanhoDaLetra: "Tamanho da letra",
    altoContraste: "Alto contraste",
    leituraNota: "A escolha fica salva na sua conta e vale em todas as telas.",
    rodape: "Uma plataforma WiniIA.",
    cnpj: "CNPJ 66.189.360/0001-91",
    abreOutroSite: "Abre outro site",
    meuPerfil: "Meu perfil",
    // Aprovados na D162 (07_VOZ §5, "Shell"): rótulos lidos pelo leitor de tela e avisos de estado.
    pularParaConteudo: "Pular para o conteúdo",
    menuPrincipal: "Menu principal",
    voceEstaEm: "Você está em",
    fechar: "Fechar",
    letraOpcoes: { A: "Letra padrão", "A+": "Letra maior", "A++": "Letra ainda maior" },
    semInternet: "Sem internet. O que já abriu continua aqui.",
    carregando: "Carregando",
    // Página que abre sem internet (D190; 07_VOZ §5, "Shell"): o texto do §5f, item 7 (D171), o botão do §5g,
    // item 24 (D177), e a aba no padrão "título | WiniEduca" (§5f, item 43).
    paginaSemInternet: {
        aba: "Sem internet | WiniEduca",
        texto: "Sem internet. Confira a conexão e tente de novo.",
        botao: "Tentar de novo",
    },
};
